// ============================================================
// ActorStatusCurtain - your character, present whenever you look away.
//
// v8.247.0, the user's respec: not a drawer you open, but GLASS that
// is simply there. The full Status view slides over the attacker
// panel whenever the cursor is NOT on the panel (you are working the
// map, the log, the target side...) and retreats the moment the
// cursor comes home to work. No button, no gesture - the state costs
// zero interactions.
//
// The whole overlay is pointer-events: none: it cannot block a click,
// intercept a hover, or flake a test - it is a projection, and the
// interactive Status tab remains the place to ACT on your character.
// AttackerPanel owns the hover state and the pin preference; this
// component only renders the glass.
// ============================================================
import clsx from '../utils/clsx';
import styles from '../styles/ActorStatusCurtain.module.css';

export default function ActorStatusCurtain({ visible, children }) {
  return (
    <div className={clsx(styles.curtain, visible && styles.visible)} data-testid="actor-curtain" aria-hidden={!visible}>
      {visible && <div className={styles.body}>{children}</div>}
    </div>
  );
}
